import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Lambda from 'aws-sdk/clients/lambda';
import './LoginPage.scss';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import { Amplify, API, Auth } from 'aws-amplify';
import { useAppContext } from '../../Lib/contextLib';
import createAwsClient from 'agnostic-aws-signature';
import pdf from './privacy_policy_070819.pdf';
import wafLogo from './waf_logo.png';
import tirLogo from './TeachingItRightLogo_Horizontal_FullColor.png';
import loading from './../../loading-gif-png-5.gif';
import awsconfigDEV from '../../awsconfiguration-dev.json';
import awsconfigPRO from '../../awsconfiguration-pro.json';

import { getGPUTier } from 'detect-gpu'


const LoginPage = (props) => {
  const myAPI = 'TIR';
  const path = '/v3/student/login';
  const myInit = {
    body: { school_identifier: '', username: '', password: '' },
  };
  const [gpu, setGpu] = useState('');
  useEffect(() => {
    (async () => {
      await getGPUTier().then((rel)=>{
        setGpu(rel.gpu)
      });
    })();
    if(props.schoolId && props.username && props.password){
      setCredentials({
        schoolId: props.schoolId,
        username: props.username,
        password: props.password,
      });
      localStorage.setItem('schoolId', props.schoolId);
    }
  }, []);
  const { userHasAuthenticated } = useAppContext();
  const dispatch = useDispatch();
  const [credentials, setCredentials] = useState({
    schoolId: '',
    username: '',
    password: '',
  });
  const [isDisabled, setIsDisabled] = useState(false);
  const [error_message, setError_message] = useState('Invalid Login');
  const [login_loading, setLogin_loading] = useState(false);


  let token, user, domain, identity_id, endpoint;

  const navigate = useNavigate();
  
  try{
    if (!window.location.href.includes('wearefriends.cool')) {
      Amplify.configure(awsconfigDEV);
      Auth.configure(awsconfigDEV);
      endpoint = awsconfigDEV.API.endpoints[0].endpoint
    }
    else {
      if (window.location.href.includes('staging-web')){
        Amplify.configure(awsconfigDEV);
        Auth.configure(awsconfigDEV);
        endpoint = awsconfigDEV.API.endpoints[0].endpoint
      }
      else{
        Amplify.configure(awsconfigPRO);
        Auth.configure(awsconfigPRO);
        endpoint = awsconfigPRO.API.endpoints[0].endpoint
      }
    }
  }
  catch(e) {
    console.log(e)
  }

  dispatch({ type: 'SET_ENDPOINT', payload: endpoint });

  // const [clientHeight, setVh] = useState(window.innerHeight);
  // const [clientWidth, setVw] = useState(window.innerWidth);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setVh(window.innerHeight);  
  //     setVw(window.innerWidth);
  //   };
  //   window.addEventListener('resize', handleResize);
  //   return () => {
  //     window.removeEventListener('resize', handleResize);
  //   };
  // }, [clientHeight, clientWidth]);

  // useEffect(() => {
  //   if(clientWidth < 700) {
  //     navigate('/error', {state: { size: true }});
  //   }
  // }, [clientWidth]);

  function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    // var expires = "expires="+ exdays;
    document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=.wearefriends.cool;path=/";
  }

  const handleChange = ({ target }) => {
    if (target.name === 'schoolId') {
      localStorage.setItem('schoolId', target.value);

      setCredentials({
        schoolId: target.value,
        username: credentials.username,
        password: credentials.password,
      });
    } else if (target.name === 'username') {
      setCredentials({
        schoolId: localStorage.getItem('schoolId'),
        username: target.value,
        password: credentials?.password,
      });
      if (target.value.length > 1 && credentials.password.length > 3) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else if (target.name === 'password') {
      setCredentials({
        schoolId: localStorage.getItem('schoolId'),
        username: credentials.username,
        password: target.value,
      });
      if (credentials.username.length > 1 && target.value.length > 3) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    }
  };

  const loginAccessUser = async (lAPI, path, body) => {
    document.getElementById('warning').style.display = 'none';
    setLogin_loading(true);
    dispatch({ type: 'CLEAR' });

    localStorage.clear();

    localStorage.setItem('schoolId', credentials.schoolId);

    const data = await API.post(lAPI, path, body)
      .then((response) => {
        token = response?.token;
        identity_id = response?.identity_id;
        domain = 'cognito-identity.amazonaws.com';
      })
      .catch((error) => {
        document.getElementById('warning').style.display = 'block';
        setLogin_loading(false);
        setError_message(error.response.data.message);
      });

    await getAWSFederatedInfo();

    localStorage.setItem('token', 'true');

    userHasAuthenticated(true);
  };

  const getAWSFederatedInfo = async () => {
    await Auth.federatedSignIn(
      domain,
      {
        token,
        identity_id, // Optional
        // expires_at: expiresIn * 1000 + new Date().getTime() // the expiration timestamp
      },
      user
    )
      .then((cred) => {
        // If success, you will get the AWS credentials
        return Auth.currentAuthenticatedUser();
      })
      .then((user) => {
        // If success, the user object you passed in Auth.federatedSignIn
        getStudentInformation();
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const getStudentInformation = async () => {
    const { accessKeyId, secretAccessKey, sessionToken, expiration } = await Auth.currentCredentials();
    dispatch({ type: 'SET_EXPIRATION', payload: Math.floor(new Date(expiration) / 1000) });
    const awsClient = createAwsClient(
      accessKeyId,
      secretAccessKey,
      sessionToken,
      {
        region: 'us-east-1', // Your AWS resource region
        endpoint:
        endpoint + '/v3/student',
      }
    );
    const signedRequest = awsClient.signRequest({
      method: 'GET', // Method of your request
      headers: {
        // Whatever headers you need to send to the resource
        accept: '*/*',
        'content-type': 'application/json',
      }, // Whatever body you need to send to the resource
    });
    const response = await fetch(signedRequest.url, {
      headers: signedRequest.headers,
    });
    const data = await response.json();
    dispatch({ type: 'SET_ID', payload: data.id });
    dispatch({ type: 'SET_SCHOOLID', payload: data.school_identifier });
    dispatch({ type: 'SET_CLASSID', payload: data.class_id });
    dispatch({ type: 'SET_FIRSTNAME', payload: data.first_name });
    dispatch({ type: 'SET_LASTNAME', payload: data.last_name });
    dispatch({ type: 'SET_MODULE', payload: data.current_module });
    dispatch({ type: 'SET_GRADE', payload: data.grade });
    dispatch({ type: 'SET_RECEIVEDCOIN', payload: data.receivedcoin });
    await getStudentModules(data.grade);
    await getStudentInfluncer();
    await getStreamVideoCookies();
  };

  const getStreamVideoCookies = async () => {
    await Auth.currentCredentials().then((credentials) => {
      const lambda = new Lambda({
        region: 'us-east-1',
        credentials: Auth.essentialCredentials(credentials),
      });
      lambda.invoke(
        // {
        //   FunctionName: 'getSignedCookieValuesWithDomain',
        //   InvocationType: 'RequestResponse',
        //   LogType: 'Tail',
        //   Payload: '{"domain": "https://d1l6i999lj1s90.cloudfront.net"}'
        // },
        {
          FunctionName: (!window.location.href.includes('wearefriends.cool')) ?  'getWebSignedCookieValues' : window.location.href.includes('staging') ? 'getWebSignedCookieValues' : 'getSignedCookieValuesWithDomain',
          Payload: null,
        },
        function (err, data) {
          if (err) console.log(err, err.stack);
          // an error occurred
          else {
            data = JSON.parse(data.Payload);
            //delete cookie first
            setCookie('CloudFront-Policy', '', 0);
            setCookie('CloudFront-Signature', '', 0);
            setCookie('CloudFront-Key-Pair-Id', '', 0);

            //set the cookie
            setCookie('CloudFront-Policy', data['CloudFront-Policy'], 1);
            setCookie('CloudFront-Signature', data['CloudFront-Signature'], 1);
            setCookie('CloudFront-Key-Pair-Id', data['CloudFront-Key-Pair-Id'], 1);
            var secret = ""
            if(!window.location.href.includes('wearefriends.cool')){
              secret = '?Key-Pair-Id=' +
              data['CloudFront-Key-Pair-Id'] +
              '&Signature=' +
              data['CloudFront-Signature'] +
              '&Expires=' +
              data['CloudFront-Expires'] +
              '&Policy=' +
              data['CloudFront-Policy'];
            }
            dispatch({ type: 'SET_COOKIE', payload: secret });
            navigate('/unitPage');
          }
        }
      );
    });
  };

  const getStudentInfluncer = async () => {
    const { accessKeyId, secretAccessKey, sessionToken } =
      await Auth.currentCredentials();
    const awsClient = createAwsClient(
      accessKeyId,
      secretAccessKey,
      sessionToken,
      {
        region: 'us-east-1', // Your AWS resource region
        endpoint:
        endpoint + '/v3/student/influencers',
      }
    );
    const signedRequest = awsClient.signRequest({
      method: 'GET', // Method of your request
      headers: {
        // Whatever headers you need to send to the resource
        accept: '*/*',
        'content-type': 'application/json',
      }, // Whatever body you need to send to the resource
    });
    const response = await fetch(signedRequest.url, {
      headers: signedRequest.headers,
    });
    const data = await response.json();
    for (const indx in data.influencers) {
      if (data.influencers[indx].setup || data.influencers[indx].main_setup) {
        dispatch({
          type: `SET_INFLUENCER${data.influencers[indx].position}ID`,
          payload: data.influencers[indx].id,
        });
      }
    }
  };

  const getStudentModules = async (grade) => {
    const { accessKeyId, secretAccessKey, sessionToken } =
      await Auth.currentCredentials();

    const awsClient = createAwsClient(
      accessKeyId,
      secretAccessKey,
      sessionToken,
      {
        region: 'us-east-1', // Your AWS resource region
        endpoint:
          endpoint + '/v3/student/modules/',
      }
    );
    const signedRequest = awsClient.signRequest({
      method: 'GET', // Method of your request
      headers: {
        // Whatever headers you need to send to the resource
        accept: '*/*',
        'content-type': 'application/json',
      },
    });
    const response = await fetch(signedRequest.url, {
      headers: signedRequest.headers,
    });
    const data = await response.json();
    const moduleName = [];
    for (const indx in data.modules) {
      moduleName.push({name:data.modules[indx].name, days:data.modules[indx].day_completed});
      if (data.modules[indx].name === 'Distance') {
        dispatch({
          type: 'SET_MODULE5_INITIALSTATE',
          payload: data.modules[indx],
        });
      }
      if (data.modules[indx].name === 'Close') {
        dispatch({
          type: 'SET_MODULE10_INITIALSTATE',
          payload: data.modules[indx],
        });
      }
      if (data.modules[indx].name === 'ActiveListening') {
        dispatch({
          type: 'SET_MODULE15_INITIALSTATE',
          payload: data.modules[indx],
        });
      }
      if(data.modules[indx].name === 'Caring'){
        dispatch({
          type: 'SET_MODULE20_INITIALSTATE',
          payload: data.modules[indx],
        });
        if(data.modules[indx].day_completed === 9 || grade === "Free Play"){
          getStudentFreeplay();
        }
      }
    }
  };

  const getStudentFreeplay = async () => {
    const { accessKeyId, secretAccessKey, sessionToken } =
      await Auth.currentCredentials();

    const awsClient = createAwsClient(
      accessKeyId,
      secretAccessKey,
      sessionToken,
      {
        region: 'us-east-1', // Your AWS resource region
        endpoint:
          endpoint + '/v3/student/freeplay/',
      }
    );
    const signedRequest = awsClient.signRequest({
      method: 'GET', // Method of your request
      headers: {
        // Whatever headers you need to send to the resource
        accept: '*/*',
        'content-type': 'application/json',
      },
    });
    const response = await fetch(signedRequest.url, {
      headers: signedRequest.headers,
    });
    const data = await response.json();
    if(data.freeplays.length === 0){
      dispatch({
        type: 'SET_FREEPLAY_LEVEL1_INITIALSTATE',
        payload: null,
      });
    }
    if(data.freeplays.length === 1){
      const categories = Object.keys(data.freeplays[0].progress);
      var progressCount = 0
      categories.forEach(category => {
        const totalItems = Object.values(data.freeplays[0].progress[category]).length;
        const unlockedCount = Object.values(data.freeplays[0].progress[category]).filter(value => value.unlocked === 1).length;
        // Ensure that the unlockedCount is what you expect based on the total possible items
        if ((unlockedCount === 5 && totalItems === 5) || 
            (unlockedCount === 6 && totalItems === 6) || 
            (unlockedCount === 3 && totalItems === 3) ||
            (unlockedCount === 10 && totalItems === 10)) {
            progressCount++;
        }
      });
      if(progressCount === 8){
        dispatch({
          type: 'SET_FREEPLAY_LEVEL2_INITIALSTATE',
          payload: null,
        });
      }
    }
    else if(data.freeplays.length === 2){
      const categories = Object.keys(data.freeplays[1].progress);
      var progressCount = 0
      categories.forEach(category => {
        const totalItems = Object.values(data.freeplays[1].progress[category]).length;
        const unlockedCount = Object.values(data.freeplays[1].progress[category]).filter(value => value.unlocked === 1).length;
        // Ensure that the unlockedCount is what you expect based on the total possible items
        if ((unlockedCount === 5 && totalItems === 5) || 
            (unlockedCount === 6 && totalItems === 6) || 
            (unlockedCount === 3 && totalItems === 3) ||
            (unlockedCount === 10 && totalItems === 10)) {
            progressCount++;
        }
      });
      if(progressCount === 8){
        dispatch({
          type: 'SET_FREEPLAY_LEVEL3_INITIALSTATE',
          payload: null,
        });
      }
    }
    else if(data.freeplays.length === 3){
      const categories = Object.keys(data.freeplays[2].progress);
      var progressCount = 0
      categories.forEach(category => {
        const totalItems = Object.values(data.freeplays[2].progress[category]).length;
        const unlockedCount = Object.values(data.freeplays[2].progress[category]).filter(value => value.unlocked === 1).length;
        // Ensure that the unlockedCount is what you expect based on the total possible items
        if ((unlockedCount === 5 && totalItems === 5) || 
            (unlockedCount === 6 && totalItems === 6) || 
            (unlockedCount === 3 && totalItems === 3) ||
            (unlockedCount === 10 && totalItems === 10)) {
            progressCount++;
        }
      });
      if(progressCount === 8){
        dispatch({
          type: 'SET_FREEPLAY_LEVEL4_INITIALSTATE',
          payload: null,
        });
      }
    }
    for (const indx in data.freeplays) {
      if (data.freeplays[indx].name === 'level1') {
        dispatch({
          type: 'SET_FREEPLAY_LEVEL1_INITIALSTATE',
          payload: data.freeplays[indx],
        });
      }
      if (data.freeplays[indx].name === 'level2') {
        dispatch({
          type: 'SET_FREEPLAY_LEVEL2_INITIALSTATE',
          payload: data.freeplays[indx],
        });
      }
      if (data.freeplays[indx].name === 'level3') {
        dispatch({
          type: 'SET_FREEPLAY_LEVEL3_INITIALSTATE',
          payload: data.freeplays[indx],
        });
      }
      if (data.freeplays[indx].name === 'level4') {
        dispatch({
          type: 'SET_FREEPLAY_LEVEL4_INITIALSTATE',
          payload: data.freeplays[indx],
        });
      }
    }
    
  };

  function findArrayElementByTitle(array, name) {
    return array.find((element) => {
      return element.name === name;
    })
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
        myInit.body = {
          school_identifier: credentials.schoolId,
          username: credentials.username,
          password: credentials.password,
        };
        loginAccessUser(myAPI, path, myInit);
    }
  }

  const handleFullscreen = () => {
    const elem = document.documentElement;

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      // Safari
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      // IE11
      elem.msRequestFullscreen();
    }
  };

  return (
    <div className='login'>
      <figure className='login-logo'>
        <img className='login-logo__image' src={wafLogo} alt='' />
      </figure>
      {login_loading && <img alt='' id='loading' src={loading} />}
      <div id='warning' className='login-error'>
        <p>{error_message}</p>
      </div>
      <div className='login-form'>
        <input
          className='login-form__input'
          type='ID'
          name='schoolId'
          placeholder='Login Identifier'
          value={localStorage.getItem('schoolId')}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />
        <input
          className='login-form__input'
          type='Username'
          name='username'
          placeholder='Username'
          value={credentials.username}
          onChange={handleChange}
          autoComplete='new-password'
          onKeyDown={handleKeyDown}
        />
        <input
          className='login-form__input'
          type='Password'
          name='password'
          placeholder='Password'
          value={credentials.password}
          onChange={handleChange}
          autoComplete='new-password'
          onKeyDown={handleKeyDown}
        />
        <div className='login-form-actions'>
          <Button
            disabled={isDisabled}
            className='login-form-btn__login'
            variant='warning'
            onClick={() => {
              myInit.body = {
                school_identifier: credentials.schoolId,
                username: credentials.username,
                password: credentials.password,
              };
              loginAccessUser(myAPI, path, myInit);
            }}
          >
            SIGN IN
          </Button>
        </div>
      </div>
      <footer className='login-footer'>
        <p>
          By continuing, you agree to our {''}
          <a href={pdf} target='_blank' rel='noreferrer'>
            Terms &#38; Conditions
          </a>
          {''} and {''}
          <a href={pdf} target='_blank' rel='noreferrer'>
            Privacy Policy
          </a>
        </p>
        <img id='tirLogo' className='login-footer__logo' src={tirLogo} alt='' />
      </footer>
    </div>
  );
};

export default LoginPage;
